import {
  PkAccordionItem,
  PkAccordionItemContent,
  PkAccordionItemTitle,
  PkListStatItem,
} from '@uefadigital/panenka-react';

interface NormalizedObject {
  [key: string]: Record<string, string>;
}

interface StatsUnitData {
  statistic: NormalizedObject;
  expand: boolean;
  heading: string;
  isDesktop: boolean;
  isPDFPrint?: boolean;
}

export const StatsUnit = ({ statistic, expand, heading, isDesktop, isPDFPrint = false }: StatsUnitData) => {
  const statisticItem = (statisticObj: NormalizedObject, expanded: boolean) => {
    const statisticArr = Object.entries(statisticObj);

    if (!statisticArr.length) return <div />;

    if (isPDFPrint) {
      return (
        <div>
          <div className="pk-font-size--xl2 pk-line-height--sm pk-font-style--normal pr-font-size--14 pk-py--12 pk-font--comp-bold">
            {heading}
          </div>
          {statisticArr.map((statisticEl) => (
            <div className="pk-mb--xs2" key={statisticEl[0]}>
              <PkListStatItem
                type="comparison"
                label={statisticEl[0]}
                data={Number(statisticEl[1].homeTeam)}
                secondData={Number(statisticEl[1].awayTeam)}
              />
            </div>
          ))}
        </div>
      );
    }

    return (
      <PkAccordionItem
        hasDivider={false}
        expanded={expanded}
        className="pk-bg--elevation-01 pk-p--m pk-px-md--xl pk-py-md--l"
      >
        <PkAccordionItemTitle
          iconPosition="right"
          circleIcon={false}
          iconColor={isPDFPrint ? 'interaction-high-contrast' : 'text-02'}
          textColor="ui-06"
          className={
            isPDFPrint
              ? 'pk-font-size--m pk-line-height--xs pk-font--comp-regular'
              : 'pk-font-size--xl pk-line-height--md pk-font--comp-regular'
          }
        >
          {heading}
        </PkAccordionItemTitle>
        <PkAccordionItemContent>
          {statisticArr.map((statisticEl) => (
            <PkListStatItem
              key={statisticEl[0]}
              className={isPDFPrint ? 'pk-mb--xs2' : 'pk-mb--s'}
              type="comparison"
              label={statisticEl[0]}
              data={Number(statisticEl[1].homeTeam)}
              secondData={Number(statisticEl[1].awayTeam)}
            />
          ))}
        </PkAccordionItemContent>
      </PkAccordionItem>
    );
  };

  return <div className={`pk-my--0 ${isDesktop ? 'pk-mb--m' : ''}`}>{statisticItem(statistic, expand)}</div>;
};
